import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "far fa-bell fa-2x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-semi-bold has-text-grey-dark is-size-5" }, "Mensagens", -1)
const _hoisted_5 = { class: "tag is-warning has-text-weight-semibold is-size-6" }
const _hoisted_6 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnreadNotificationRow = _resolveComponent("UnreadNotificationRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", null, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.unreadNotificationsCount), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unreadNotifications, (unreadNotification) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_UnreadNotificationRow, { "unread-notification": unreadNotification }, null, 8, ["unread-notification"])
      ]))
    }), 256))
  ]))
}